class Monitoring.Models.MovistarRuleInterval extends Backbone.Model
  urlRoot: '/monitoring/movistar_rule_intervals'

  defaults: ->
    active: true
    has_advance_options: false
    start_date: undefined
    end_date: null

  validateFields: ->
    @validateLengthOfStrings()

  getFormattedStartDate: (format = 'YYYY-MM-DD | HH:mm')  ->
    return '' unless @get('start_date')
    Date.create(@get('start_date')).format(format)

  getFormattedEndDate: (format = 'YYYY-MM-DD | HH:mm')  ->
    return '' unless @get('end_date')
    Date.create(@get('end_date')).format(format)

  getIsActive: ->
    if @get('active')
      'SI'
    else
      'NO'

  getHasAdvanceOptions: ->
    if @get('has_advance_options')
      'SI'
    else
      'NO'

class Monitoring.Collections.MovistarRuleIntervalsCollection extends Backbone.Collection
  model: Monitoring.Models.MovistarRuleInterval
